import React, { FC, useCallback, useContext } from 'react';
import AnimatedCard from '../../AnimatedCard';
import { observer } from 'mobx-react-lite';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { getSVG } from '@/components/Common/styles/mixins';
import styles from './index.module.scss';

const InterparkEventCard: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/${path}`), []);
  return (
    <AnimatedCard
      className={styles.cardContainer}
      type={'white'}
      title={
        <div className={styles.title}>
          <img className={styles.logo} src={getResourcePath('v8/nol_ticket.png')} alt={'NOL 티켓'} />
          <br />
          toping 멤버십
          <div className={styles.blue}>연간 가입비 지원</div>
          <p className={styles.subTitle}>(1만원권)</p>
        </div>
      }
      image={
        <img className={styles.image} src={getResourcePath('v9/v9_toping_membership.png')} alt={'토피 멤버쉽 이벤트'} />
      }
      description={{
        bold: 'NOL 티켓 회원이 NOL 티켓 웹/앱에서\n' + 'toping 멤버십 1만원권 결제 시',
        normal: '단, toping 멤버십 1만원권 외 다른 권종의 \n' + '멤버십은 대상 제외',
      }}
      onDetailClick={() => (store.isTopingMemberShipBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: '해외여행·공연·오프라인 혜택까지 NOL 카드 이벤트',
        motherPageVersion: store.version,
        motherPageSectionType: '이벤트',
        motherPageSectionName: '인터파크 toping 멤버십 1만원권 가입비 1만원 지원',
        motherPageSectionNameSubTitle: '',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(InterparkEventCard);
